import { __ } from '@oat-sa-private/ui-core';

export function getCategories() {
    return {
        environment: __('Environment'),
        examinee: __('Test taker'),
        proctorStaff: __('Proctor/Staff'),
        technical: __('Technical'),
        other: __('Other')
    };
}

export function getSubcategories() {
    return {
        environment: {
            10010: __('Comfort'),
            10020: __('Disturbance'),
            10030: __('Noise'),
            10040: __('Power outage'),
            10050: __('Weather'),
            10999: __('Other')
        },
        examinee: {
            20010: __('Behaviour'),
            20020: __('Complaint'),
            20030: __('Id/Authorization'),
            20040: __('Illness'),
            20050: __('Late'),
            20060: __('Navigation'),
            20999: __('Other')
        },
        proctorStaff: {
            30010: __('Behaviour'),
            30020: __('Compliance'),
            30030: __('Error'),
            30040: __('Late'),
            30999: __('Other')
        },
        technical: {
            40010: __('Freezing'),
            40020: __('Launching'),
            40030: __('Network'),
            40040: __('Printing'),
            40050: __('Testing workstation'),
            40999: __('Other')
        },
        other: {
            999: '-'
        }
    };
}
